import React from 'react'

const Hero = () => {
  return (
    <div className='flex flex-col md:flex-row py-20'>
        <div className='w-full lg:w-1/2'>
            <img src="/images/escapist.webp" alt="" />
        </div>
        <div className='w-full px-12 md:px-0 py-6 md:py-0 lg:w-1/2 flex flex-col justify-center text-[#1b1b1b]'>
            <h1 className='text-[24px] md:text-[36px] font-semibold w-full md:w-[70%] mb-2'>The Escapist Cabin that pays for itself.</h1>
            <p className='text-[16px] md:text-[20px] w-full md:w-[75%]'>Designed from the ground up for short term rentals. Reserve yours for $1,000.</p>
            <button className='bg-[#1b1b1b] text-white rounded-full px-10 md:px-16 py-3.5 md:py-4 text-[14px] md:text-[18px] font-medium mt-4 md:mt-6 lg:mt-12 w-full md:max-w-[275px]'>Reserve Now</button>
        </div>
    </div>
  )
}

export default Hero